import React, { Component } from 'react';
import { BsyUtils } from '../../utils/Utils';
import BsySelect from "../BsySelect";
import './index.css'

class BsyTurnPage extends Component {

    static defaultProps = {
        skip: 0,
        limit: 20,
        count: 0,
        hasTurnLast: false,
        hasCount: true,
    }

    constructor(props) {
        super(props);
        this.myCreateRef = React.createRef();
        this.turnEl = React.createRef();
        this.state = {
            limit: props.limit,
            skip: props.skip,
            hasCount: props.hasCount,
            selectDataId: props.selectDataId,
            count: props.count,
            items: [
                {
                    text: React.language('pagination.limit', { limit: 20 }),
                    value: 20,
                    selected: true
                }, {
                    text: React.language('pagination.limit', { limit: 50 }),
                    value: 50,
                    selected: false
                }, {
                    text: React.language('pagination.limit', { limit: 100 }),
                    value: 100,
                    selected: false
                }
                // , {
                //     text: React.language('pagination.limit', { limit: 200 }),
                //     value: 200,
                //     selected: false
                // }
            ]
        }
    }

    componentDidMount() {
        if (this.props.getContext) {
            this.props.getContext(this)
        }
    }

    getPageValue = (ref) => {
        this.pageValue = ref
    }

    prev = () => {
        const { skip } = this.state
        const { skipChange } = this.props
        if (skip > 0) {
            this.setState({ skip: skip - 1 }, () => {
                this.myCreateRef.current.value = skip;
                skipChange && skipChange(skip - 1)
            })
        }
    }

    next = () => {
        const { limit, skip, count } = this.state
        const { skipChange } = this.props
        if (skip + 1 < Math.ceil(count / limit)) {
            this.setState({ skip: skip + 1 }, () => {
                this.myCreateRef.current.value = skip + 2;
                skipChange && skipChange(skip + 1)
            });
        }
    }
    first = () => {
        let skip = 1;
        const { skipChange } = this.props
        if (skip > 0) {
            this.setState({ skip: skip - 1 }, () => {
                this.myCreateRef.current.value = skip;
                skipChange && skipChange(skip - 1)
            })
        }
    }

    last = () => {
        const { count, limit } = this.state
        const { skipChange } = this.props
        const maxPage = Math.ceil(count / limit)
        this.setState({ skip: maxPage - 1 }, () => {
            skipChange && skipChange(maxPage - 1)
        });
    }
    inputValue = () => {
        const { count, limit, skip } = this.state
        const { skipChange } = this.props
        const pageInputValue = this.myCreateRef.current.value
        const maxPage = Math.ceil(count / limit)
        if ((skip >= 0) && (skip + 1 <= maxPage)) {
            this.setState({ skip: pageInputValue - 1 }, () => {
                skipChange && skipChange(pageInputValue - 1)
            });
        } else {
            // this.myCreateRef.current.value = maxPage;
            if (pageInputValue <= 0) {
                this.setState({ skip: 0 }, () => {
                    skipChange && skipChange(0)
                });
            } else {
                this.setState({ skip: maxPage - 1 }, () => {
                    skipChange && skipChange(maxPage - 1)
                });
            }

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            selectDataId: nextProps.selectDataId,
            limit: nextProps.limit,
            count: nextProps.count,
            hasCount: nextProps.hasCount,
            skip: nextProps.skip
        })
    }

    setSelectData = (selectDataId) => {
        this.setState({ selectDataId: selectDataId })
    }

    render() {
        const { items, skip, hasCount, selectDataId, count, limit } = this.state
        const { styleType, listLimitChange, noLimitBtn } = this.props
        return (
            <div ref={(ref) => {
                if (ref && ref.getElementsByClassName("BsySelect")[0]) {
                    if (ref.clientWidth <= 400) {
                        ref.getElementsByClassName("BsySelect")[0].style.display = "none"
                    } else {
                        ref.getElementsByClassName("BsySelect")[0].style.display = "block"
                    }
                }
            }} className={styleType ? "BsyTurnPage " + styleType : "BsyTurnPage"}>
                {hasCount && <div className="pageCount">
                    {!noLimitBtn &&
                        <BsySelect
                            allowBlank={false}
                            searchable={false}
                            theme={this.props.theme}
                            minWidth={150} listLimitChange={listLimitChange} getValue={this.getPageValue}
                            value={limit} items={items} />}
                    <div className="total" title={React.language('map.data.num', { num: count })}>
                        {React.language('map.data.num', { num: count })}
                    </div>
                    {
                        !BsyUtils.isObjectEmpty(this.selectDataId) && <div className="total" >{"已选中" + selectDataId.length + "条数据"}</div>
                    }
                </div>
                }
                {
                    this.props.onBsyTurnPageMid && this.props.onBsyTurnPageMid()
                }

                <div className="turnPage">
                    <input type="text" ref={this.myCreateRef} onBlur={this.inputValue} value={skip + 1} maxLength="4" onInput={(event) => {
                        event.target.value = event.target.value.replace(/[^\d]/g, '');
                        this.setState({
                            skip: event.target.value - 1
                        })
                    }} />
                    <span>/ {count === 0 ? 1 : Math.ceil(count / limit)
                    }</span>
                    <div className="turn">
                        {
                            this.props.hasTurnLast && <div onClick={this.first} className={"first turn-btn " + (skip + 1 > 1 ? "" : 'disabled')}>
                                <i className="icon-double-left">
                                </i>
                            </div>
                        }
                        <div onClick={this.prev} className={"prev turn-btn " + (skip + 1 > 1 ? "" : 'disabled')}>
                            <i className="icon-bsy-left">

                            </i>
                        </div>
                        <div onClick={this.next} className={"next turn-btn " + (skip + 1 < Math.ceil(count / limit) ? "" : 'disabled')}>
                            <i className="icon-bsy-right">

                            </i>
                        </div>
                        {
                            this.props.hasTurnLast && <div onClick={this.last} className={"last turn-btn " + (skip + 1 < Math.ceil(count / limit) ? "" : 'disabled')}>
                                <i className="icon-double-right">
                                </i>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default BsyTurnPage;